<template>
  <v-container fluid pt-0>
    <v-card flat color="background">
      <v-card-title>{{currentSetting.display_name}}</v-card-title>
      <v-card-subtitle>{{currentSetting.description}}</v-card-subtitle>
      <v-card-text>
        <v-scroll-x-transition group>
          <v-row
            class="ma-0 pa-0 align-center"
            v-for="(item, index) in currentSetting.setting_options"
            :key="index"
          >
            <v-col class="ma-0 pa-0 my-2" cols="12" sm="12" md="8">
              <v-card>
                <v-card-text>
                  <v-row justify="center" align="center" align-content="center">
                    <v-col cols="12" md="9">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <div>
                            <p class="pa-0 ma-0 subtitle-1 font-weight-bold">{{item.display_name}}</p>
                            <p class="pa-0 ma-0 subtitle-2 font-weight-regular">{{item.description}}</p>
                          </div>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <span>
                            <span v-if="item.value_type === 'boolean'">
                              <v-switch inset class hide-details v-model="item.current_value"></v-switch>
                            </span>
                            <span v-if="item.value_type === 'string'">
                              <v-text-field v-model="item.current_value"></v-text-field>
                            </span>
                            <span v-if="item.value_type === 'number'">
                              <v-text-field type="number" v-model.number="item.current_value"></v-text-field>
                            </span>
                            <span v-if="item.value_type === 'currency'">
                              <v-text-field
                                v-currency="{'distraction-free': false, currency: null, locale: 'en', precision: 2, 'auto-decimal-mode': true}"
                                v-model.number="item.current_value"
                                prefix="$"
                              ></v-text-field>
                            </span>
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3" class="text-right">
                      <v-btn
                        v-if="item.value_type !== 'button'"
                        :disabled="enableButton(item,index)"
                        @click="updateSetting(item, index)"
                        color="primary"
                      >
                        <v-icon>check</v-icon>
                      </v-btn>
                      <v-btn
                        @click="applyButtonAction(item)"
                        v-else
                        class="mt-2"
                        color="primary"
                      >
                        <v-icon
                          v-if="item.display_name.toLowerCase().indexOf('sync') !== -1"
                          left
                        >refresh</v-icon>
                        {{item.current_value}}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-scroll-x-transition>
      </v-card-text>
    </v-card>
    <!-- OVERLAY -->
    <v-overlay opacity="0.85" :value="overlay.status" z-index="100">
      <v-layout row wrap justify-center mb-11>
        <PlugLoader />
      </v-layout>
      <v-row justify="center">
        <v-col cols="11" md="12" class="text-left">
          <transition name="fade" mode="out-in">
            <blockquote
              :class="$vuetify.breakpoint.smAndDown?'mx-2':'mx-11'"
              v-if="overlay.quoteStatus"
              cite="http://www.worldwildlife.org/who/index.html"
            >
              {{overlay.quote.quote}}
              <footer class="font-weight-bold text-right">- {{overlay.quote.author}}</footer>
            </blockquote>
          </transition>
        </v-col>
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
import { getQuote } from '@/utlis/helper'
import axios from '@/clients/_client'
import { LocationAPI } from '@/clients/locations/locations.api'
import { CurrencyDirective } from 'vue-currency-input'
import PlugLoader from '@/components/custom-components/plug-loader'
export default {
  directives: {
    currency: CurrencyDirective
  },
  components: {
    PlugLoader
  },
  data() {
    return {
      settings: [],
      currentSetting: {
        display_name: '',
        description: '',
        setting_options: []
      },
      initialSettings: '',
      overlay: {
        status: false,
        quote: '',
        quoteStatus: false
      }
    }
  },
  methods: {
    async getLocationSettings(settingsIndex) {
      let response
      try {
        response = await LocationAPI.getLocationSettings(this.$route.params.id)
      } catch (error) {
        return console.log(error)
      }
      this.settings = response.data.payload
      let currentSetting = response.data.payload[settingsIndex || this.currentSettingIndex]
      this.currentSetting.display_name = currentSetting.display_name
      this.currentSetting.description = currentSetting.desription
      for (const index in currentSetting.setting_options) {
        this.$set(this.currentSetting.setting_options, index, currentSetting.setting_options[index])
      }

      this.initialSettings = JSON.parse(JSON.stringify(this.currentSetting))
    },
    async updateSetting(item, index) {
      const data = {
        value: item.current_value,
        settings_option_id: item.id
      }
      try {
        await LocationAPI.updateLocationSettings({ locationId: this.$route.params.id, data })
      } catch (error) {
        return console.log(error)
      }
      // this.initialSettings.setting_options[index].current_value = item.current_value
      await this.getLocationSettings(this.currentSettingIndex)
      this.snackbar({ text: 'Setting updated successfully.', color: 'success', icon: 'check' })
    },
    enableButton(item, index) {
      return this.initialSettings.setting_options[index].current_value === item.current_value
    },
    async applyButtonAction(item) {
      let self = this
      if (item.request_details) {
        // load the first quote
        self.updateQuote()
        // load next few quotes
        let interval = setInterval(() => {
          self.updateQuote()
        }, 13000)
        // show the overlay
        this.overlay.status = true
        // figure out if get or post method
        let method = item.request_details.type ? item.request_details.type : item.request_details.body ? 'POST' : 'GET'
        let response
        try {
          response = await axios({
            url: item.request_details.url,
            method,
            data: item.request_details.body ? item.request_details.body : null,
            headers: item.request_details.headers
          })
        } catch (error) {
          this.$set(item, 'loading', false)
          this.overlay.status = false
          this.swal({
            title: 'Error',
            text: error.response.data.msg,
            type: 'error'
          })
          // clear the interval
          clearInterval(interval)
          return
        }
        this.overlay.status = false
        this.swal({
          title: 'Success',
          text: response.data.msg,
          type: 'success'
        })
        clearInterval(interval)
      }
    },
    async updateQuote() {
      this.overlay.quoteStatus = false
      let quote = getQuote()
      this.overlay.quote = quote
      await this.$nextTick()
      this.overlay.quoteStatus = true
    },
    resetState() {
      this.currentSetting = {
        display_name: '',
        description: '',
        setting_options: []
      }
      this.settings = []
      this.initialSettings = []
    },
    getRandomQuote() {

    }
  },
  computed: {
    currentSettingIndex() {
      return this.$route.params['index']
    }
  },
  watch: {
    currentSettingIndex: {
      handler: async function (x) {
        this.resetState()
        await this.getLocationSettings(x)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
blockquote {
  margin: 1.5em 10px;
  padding: 0.5em 10px;
  quotes: "\201C""\201D""\2018""\2019";
}
blockquote:before {
  color: #ccc;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
blockquote p {
  display: inline;
}

.is-relative {
  position: relative;
}

.is-absolute {
  position: absolute;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
